

import { Container, Grid, Box, Typography } from "@mui/material";
import useGtmScrollTracker from "../hooks/useGtmScrollTracker";

function Discover2() {


      const sectionRef = useGtmScrollTracker("Discover2");
  return (
    <Container ref={sectionRef}>
      <Grid container spacing={4} alignItems="center">


        {/* Right Side - Image */}
        <Grid item xs={6} md={6} >
          <Box>
            <Typography variant="h3" sx={{ 
              fontFamily: 'Poppins' ,
                fontSize: { xs: "20px",md:"38px", sm: "48px" },
                lineHeight:{ xs: "20px",md:"38px", sm: "48px" },
                 fontWeight: 700, mt: { xs: "30px", sm: '0px' }, 
                 textAlign: 'left', 
                 color: "#374d91" }}>
              Order with one Tap
            </Typography>
            <Typography variant="body1"
             sx={{ mt:1, 
              textAlign: "left", 
              color:"#000000B2",
             fontSize: { xs: "12px", sm: "18px", md:"18px"} ,
              lineHeight:{ xs: "20px",md:"28px", sm: "28px" },
              fontFamily: 'Poppins'  }}>
              Shop your favourite brands from Amazon & Sephora in Dubai in a tap with smooth delivery right to your door in Lebanon.
            </Typography>
          </Box>
        </Grid>
        {/* Left Side - Content */}
        <Grid item xs={6} md={6}
        >
          <Box
            component="img"
            src="/homeimg/phone-2.gif"
            // src="/homeimg/Gray_Minimalist.gif"
            alt="Discover Image"
            sx={{
              width: { xs: "100%", md: "80%" },
              borderRadius: 2,
              height: { xs: "100%", md: "600px" },
              mt: "40px",
              objectFit: "contain",
            }}
          />
        </Grid>


      </Grid>
    </Container>
  );
}

export default Discover2;
